<template>
  <el-card class="sound-activity" shadow="never">
    <div slot="header" class="header"><strong>近期音效行为</strong><span>北京时间 · 仅最高管理员可查看用户明细 · 手动刷新，不自动跳动</span></div>
    <div class="time-toolbar">
      <el-radio-group v-model="preset" size="small" @change="selectPreset">
        <el-radio-button label="10m">近10分钟</el-radio-button><el-radio-button label="1h">近1小时</el-radio-button>
        <el-radio-button label="24h">近24小时</el-radio-button><el-radio-button label="7d">近7天</el-radio-button><el-radio-button label="custom">自定义</el-radio-button>
      </el-radio-group>
      <el-date-picker v-if="preset === 'custom'" v-model="customRange" type="datetimerange" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" start-placeholder="开始分钟" end-placeholder="结束分钟" range-separator="至" />
      <el-button v-if="preset === 'custom'" size="small" type="primary" @click="applyRange">查询时间范围</el-button>
      <el-button size="small" icon="el-icon-refresh" @click="refresh">刷新记录</el-button>
    </div>
    <p class="range-note">{{ rangeLabel }}<span v-if="preset === 'custom'"> · 自定义包含结束分钟，最多31天；修改后请点击查询。</span></p>
    <el-tabs v-model="active" @tab-click="openTab">
      <el-tab-pane v-for="tab in tabs" :key="tab.key" :label="tab.label" :name="tab.key">
        <div class="search-toolbar">
          <el-input v-model="tab.sound" clearable maxlength="64" placeholder="音效名称或ID" @keyup.enter.native="search(tab)" @clear="search(tab)" />
          <el-input v-if="tab.key !== 'ranking'" v-model="tab.user" clearable maxlength="64" placeholder="用户名或用户ID" @keyup.enter.native="search(tab)" @clear="search(tab)" />
          <el-button size="small" type="primary" icon="el-icon-search" @click="search(tab)">搜索</el-button>
        </div>
        <p class="meaning" v-if="tab.key === 'downloads'">一条记录代表一次已登记下载，不代表文件一定已下载完成。累计下载沿用音效现有计数。</p>
        <p class="meaning" v-else-if="tab.key === 'favorites'">仅显示期间添加且当前仍保留的喜欢；已取消的不显示。总喜欢人数是当前人数，不是历史点击次数。</p>
        <p class="meaning" v-else>按期间下载次数、期间新增且仍保留的喜欢人数排序；不同下载人数按用户ID去重。</p>
        <div v-if="tab.error" class="error"><el-alert :title="tab.error" type="error" show-icon :closable="false" /><el-button size="small" @click="load(tab)">重试本次查询</el-button></div>
        <el-table v-else v-loading="tab.loading" :data="tab.items" stripe size="small" empty-text="这个时间范围和筛选条件下没有记录">
          <el-table-column v-if="tab.key !== 'ranking'" prop="time" :label="tab.key === 'downloads' ? '下载时间' : '喜欢时间'" width="165" />
          <el-table-column v-else type="index" label="排名" width="70" :index="(tab.page - 1) * 20 + 1" />
          <el-table-column label="音效" min-width="230"><template slot-scope="scope"><div>{{ scope.row.sound_name || '音效已删除' }}</div><small>ID：{{ scope.row.sound_id }}</small></template></el-table-column>
          <el-table-column v-if="tab.key !== 'ranking'" label="用户" min-width="180"><template slot-scope="scope"><div>{{ scope.row.username || '用户已删除' }}</div><small>ID：{{ scope.row.user_id }}</small></template></el-table-column>
          <el-table-column v-if="tab.key === 'ranking'" label="期间下载次数" width="120" align="right"><template slot-scope="scope">{{ number(scope.row.download_count) }}</template></el-table-column>
          <el-table-column v-if="tab.key === 'ranking'" label="不同下载人数" width="120" align="right"><template slot-scope="scope">{{ number(scope.row.download_users) }}</template></el-table-column>
          <el-table-column v-if="tab.key === 'ranking'" label="期间新增喜欢人数" width="150" align="right"><template slot-scope="scope">{{ number(scope.row.new_favorite_users) }}</template></el-table-column>
          <el-table-column v-if="tab.key !== 'favorites'" label="累计下载次数" width="120" align="right"><template slot-scope="scope">{{ number(scope.row.download_times) }}</template></el-table-column>
          <el-table-column v-if="tab.key !== 'downloads'" label="当前总喜欢人数" width="135" align="right"><template slot-scope="scope">{{ number(scope.row.favorite_count) }}</template></el-table-column>
        </el-table>
        <el-pagination v-if="!tab.error" class="pagination" background layout="total, prev, pager, next" :page-size="20" :total="Math.min(tab.total, 20000)" :current-page="tab.page" @current-change="page => changePage(tab, page)" />
        <p v-if="tab.total > 20000" class="meaning">共匹配 {{ number(tab.total) }} 条，仅可翻阅前1000页；请缩小时间范围或添加搜索条件。</p>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import api from '@/api/onlineUser'

// 2026-10-07：查询面板独立于旧总览。每个标签保留自己的搜索/页码，只在人工操作时查库。
const tabState = (key, label) => ({ key, label, sound: '', user: '', appliedSound: '', appliedUser: '', items: [], page: 1, total: 0, loading: false, error: '', version: 0, loaded: false })
export default {
  name: 'SoundActivity',
  data() {
    return { preset: '24h', customRange: [], applied: null, active: 'downloads', destroyed: false, tabs: [tabState('downloads', '最近下载'), tabState('favorites', '最近喜欢'), tabState('ranking', '近期热门音效榜')] }
  },
  computed: {
    rangeLabel() {
      if (!this.applied) return '尚未应用时间范围'
      if (this.applied.preset === 'custom') return '当前查询：' + this.applied.start_time + ' 至 ' + this.applied.end_time
      const duration = { '10m': 600, '1h': 3600, '24h': 86400, '7d': 604800 }[this.applied.preset]
      return '当前快照：' + this.beijingTime(this.applied.anchor - duration + 1) + ' 至 ' + this.beijingTime(this.applied.anchor) + '（翻页不移动范围）'
    }
  },
  created() { this.applyRange() },
  // 2026-10-07：离开页面废弃旧响应，不加定时器，不改变其他页面或登录状态。
  beforeDestroy() { this.destroyed = true; this.tabs.forEach(tab => tab.version++) },
  methods: {
    selectPreset() { if (this.preset !== 'custom') this.applyRange() },
    // 2026-10-07：先验证自定义分钟，再同时废弃三个标签旧数据；例如反向时间不能覆盖当前结果。
    applyRange() {
      let applied
      if (this.preset === 'custom') {
        if (!Array.isArray(this.customRange) || this.customRange.length !== 2) return this.$message.warning('请选择开始和结束分钟')
        const timestamps = this.customRange.map(value => new Date(value.replace(' ', 'T') + ':00+08:00').getTime())
        if (!timestamps.every(Number.isFinite) || timestamps[1] < timestamps[0] || timestamps[1] + 60000 - timestamps[0] > 31 * 86400000) return this.$message.warning('开始不能晚于结束，查询范围最多31天')
        applied = { preset: 'custom', start_time: this.customRange[0], end_time: this.customRange[1] }
      } else applied = { preset: this.preset, anchor: Math.floor(Date.now() / 1000) }
      this.applied = applied
      this.tabs.forEach(tab => { tab.appliedSound = tab.sound.trim(); tab.appliedUser = tab.user.trim(); this.reset(tab) })
      this.load(this.tabs.find(tab => tab.key === this.active))
    },
    // 2026-10-07：快捷刷新重新取当前时刻，自定义刷新保留已应用范围，不采用尚未提交的日期草稿。
    refresh() {
      if (!this.applied) return this.applyRange()
      if (this.applied.preset !== 'custom') this.applied = { ...this.applied, anchor: Math.floor(Date.now() / 1000) }
      this.tabs.forEach(tab => this.reset(tab))
      this.load(this.tabs.find(tab => tab.key === this.active))
    },
    reset(tab) { tab.version++; tab.page = 1; tab.items = []; tab.total = 0; tab.error = ''; tab.loaded = false; tab.loading = false },
    openTab() { const tab = this.tabs.find(item => item.key === this.active); if (!tab.loaded && !tab.loading) this.load(tab) },
    search(tab) { tab.appliedSound = tab.sound.trim(); tab.appliedUser = tab.user.trim(); this.reset(tab); this.load(tab) },
    changePage(tab, page) { if (page > 1000) return this.$message.warning('请缩小范围或添加搜索条件'); tab.page = page; this.load(tab) },
    // 2026-10-07：序号隔离迟到响应；网络/索引错误有独立重试，不伪装成空列表，不清除登录。
    async load(tab) {
      if (!this.applied) return
      const version = ++tab.version
      tab.loading = true
      tab.error = ''
      try {
        const response = await api.getSoundActivity({ ...this.applied, type: tab.key, page: tab.page, page_size: 20, sound: tab.appliedSound, user: tab.key === 'ranking' ? '' : tab.appliedUser })
        if (this.destroyed || version !== tab.version) return
        const body = response.data
        if (!body || body.code !== 1) throw new Error((body && body.msg) || '记录查询失败，请重试')
        tab.items = body.data.items
        tab.total = Number(body.data.total)
        tab.loaded = true
      } catch (error) {
        if (!this.destroyed && version === tab.version) { tab.error = error.message || String(error); tab.loaded = false }
      } finally { if (!this.destroyed && version === tab.version) tab.loading = false }
    },
    // 2026-10-07：快照显示不依赖浏览器所在时区；数字存储仍使用标准 Unix 秒。
    beijingTime(timestamp) { return new Date((timestamp + 8 * 3600) * 1000).toISOString().slice(0, 19).replace('T', ' ') },
    number(value) { return value == null ? '—' : Number(value).toLocaleString('zh-CN') }
  }
}
</script>

<style scoped lang="scss">
.sound-activity { margin-bottom: 16px; border: 0; }
.header { strong { font-size: 16px; color: #303133; } span { display: block; margin-top: 6px; color: #909399; font-size: 12px; } }
.time-toolbar, .search-toolbar { display: flex; align-items: center; flex-wrap: wrap; gap: 10px; .el-button { margin-left: 0; } }
.time-toolbar .el-date-editor { max-width: 100%; }
.search-toolbar { margin: 6px 0 12px; .el-input { width: 230px; max-width: 100%; } }
.range-note, .meaning, small { color: #909399; font-size: 12px; line-height: 1.7; }
.range-note { margin: 12px 0; overflow-wrap: anywhere; }
.pagination { text-align: right; margin-top: 16px; overflow-x: auto; }
.error { .el-button { margin-top: 10px; } }
@media (max-width: 768px) { .time-toolbar .el-radio-group { display: flex; flex-wrap: wrap; } .pagination { text-align: left; } }
</style>
